import { render, staticRenderFns } from "./booksborrowed.vue?vue&type=template&id=5a3cdd94&"
import script from "./booksborrowed.vue?vue&type=script&lang=js&"
export * from "./booksborrowed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports